import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import './Landing.css'
import { Button, IconButton, } from '@mui/material';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import FacebookIcon from '@mui/icons-material/Facebook';
import GoogleIcon from '@mui/icons-material/Google';
import FormReg from './FormReg';
const deathLine = dayjs("11/30/2021", "MM/DD/YYYY")
export default function Landing() {
    const [remainDay, setremainDay] = useState("00")
    const [remainHour, setremainHour] = useState("00")
    const [remaiSecond, setremaiSecond] = useState("00")
    const [remainMinute, setremainMinute] = useState("00")
    const [interValID, setinterValID] = useState(null)
    const [isOpenDialogReg, setisOpenDialogReg] = useState(false)
    const [isFixedBtn, setisFixedBtn] = useState(false)
    useEffect(() => {
        const intervalId = setInterval(() => {

            const deathLineDiff = deathLine.diff(dayjs())
            if (deathLineDiff <= 0){
 clearInterval(interValID)
  setremainDay(0)
            setremainHour(0)
            setremaiSecond(0)
            setremainMinute(0)
}else{
            let dayDiff = Math.floor(deathLineDiff / (24 * 60 * 60 * 1000));
            const daysms = deathLineDiff % (24 * 60 * 60 * 1000);
            let hourDiff = Math.floor(daysms / (60 * 60 * 1000));
            let hoursms = deathLineDiff % (60 * 60 * 1000);
            let minuteDiff = Math.floor(hoursms / (60 * 1000));
            let minutesms = deathLineDiff % (60 * 1000);
            let secondDiff = Math.floor(minutesms / 1000)
            if ((dayDiff + "").length < 2) dayDiff = "0" + dayDiff
            if ((hourDiff + "").length < 2) hourDiff = "0" + hourDiff
            if ((secondDiff + "").length < 2) secondDiff = "0" + secondDiff
            if ((minuteDiff + "").length < 2) minuteDiff = "0" + minuteDiff
            setremainDay(dayDiff)
            setremainHour(hourDiff)
            setremaiSecond(secondDiff)
            setremainMinute(minuteDiff)}
        }, 1000)
        setinterValID(intervalId)
        window.onscroll = function (ev) {
            if (document.body.offsetHeight - (window.innerHeight + window.scrollY) < 256) {
                setisFixedBtn(false)
            }
            else {
                setisFixedBtn(true)
            }
        };
    }, [])

    const scrollToEl = (idName) => {
        document.querySelector('#' + idName).scrollIntoView({
            behavior: 'smooth'
        });
    }

    return (
        <div className="container-fluid">
            <div className="row header pt-3 pb-3">
                <div className="container-fluid custom-container" >
                    <div className="row">

                        <div className="col-md-3">
                            <img src="/images/logo.png" alt="" />
                        </div>
                        <div className="col-md-6 offset-md-1">
                            <div className="d-flex menu-container">

                                <span className="menu-text" onClick={() => scrollToEl("about")}>
                                    VỀ CHƯƠNG TRÌNH
                                </span>
                                <span className="menu-text" onClick={() => scrollToEl("rule")}>
                                    ĐIỀU KIỆN ÁP DỤNG
                                </span>
                                <span className="menu-text" onClick={() => scrollToEl("reg")}>
                                    ĐĂNG KÝ
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12 p-0">
                    <div className="banner">
                        <img src="/images/banner.png" alt="" className="banner-img" />
                    </div>
                </div>
            </div>
            <div className="row" id="about">
                <div className="container-fluid custom-container" >
                    <div className="row">
                        <div className="col-md-6">
                            <div className="content-left">
                                <span className="content-title mt-5" >
                                    MÔ TẢ CHƯƠNG TRÌNH
                                </span>

                            </div>

                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6 pr-0">

                            <span className="content-detail">
                                {`  Để học sinh được tiếp tục học tập trong đại dịch Covid có sự nỗ lực, hy sinh âm thầm của: thầy cô giáo, cha mẹ và các y bác sĩ. Thầy cô dạy dỗ, cha mẹ vừa dạy vừa học cùng con ở nhà; thầy thuốc và y bác sỹ chiến đấu với bệnh dịch cho các em sự an toàn. Đó là 3 người Thầy lớn của học sinh Việt Nam năm 2021.\n
                                    Tri ân những công lao to vô cùng lớn ấy, nhân ngày Nhà giáo Việt Nam 20-11, Apax Leaders dành tặng hàng ngàn suất học bổng 5 triệu VNĐ cho người thân của các phụ huynh đang công tác trong ngành y tế và giáo dục trên toàn quốc.\n
                                    Chúng ta đẹp hơn khi biết sống tri ân. Hãy đăng ký để nhận quà hoặc gửi tặng món quà ý nghĩa này đến những người thầy yêu quý của mình.`}
                            </span>
                        </div>
                        <div className="col-md-6">
                            <img src="/images/content.png" alt="" style={{ width: "100%" }} />
                        </div>
                    </div>
                    <div className="row" id="rule">
                        <div className="col-md-6 mt-3">
                            <div className="content-left">
                                <span className="content-title" >
                                    ĐIỀU KIỆN ÁP DỤNG
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4  mt-5">
                            <div className="condition text-left d-flex">
                                <img src="/images/clock-icon.png" alt="" width="60" height="60" />
                                <div className="condition-detail ">
                                    <span className="condition-detail-title">THỜI GIAN</span>
                                    <span className="condition-detail-detail">Đến hết <b>30/11/2021</b></span>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4  mt-5">
                            <div className="condition text-left d-flex">
                                <img src="/images/voucher.png" alt="" width="60" height="60" />
                                <div className="condition-detail ">
                                    <span className="condition-detail-title">HÌNH THỨC ÁP DỤNG</span>
                                    <span className="condition-detail-detail">Voucher trị giá <br /><b>5 triệu VNĐ</b></span>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4  mt-5">
                            <div className="condition text-left d-flex">
                                <img src="/images/location.png" alt="" width="50" height="60" />
                                <div className="condition-detail ">
                                    <span className="condition-detail-title">PHẠM VI ÁP DỤNG</span>
                                    <span className="condition-detail-detail"><b>Trên toàn quốc</b></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row  mt-5">
                        <div className="col-md-12">
                            <div className="condition text-left d-flex">
                                <img src="/images/rule.png" alt="" width="60" height="75" />
                                <div className="condition-detail">
                                    <span className="condition-detail-title">QUY ĐỊNH</span>
                                    <ul className="rule-list mt-3">
                                        <li> Học bổng không có giá trị quy đổi thành tiền mặt.</li>
                                        <li>Áp dụng cho tất cả các khóa học <b> Igarten, April, 4.0 và AVS</b> từ 12 tháng.</li>
                                        <li>Cho phép cộng gộp với một số chương trình ưu đãi khác*</li>
                                        <li>Học bổng chỉ có giá trị sử dụng <b> 01</b> lần cho<b> 01</b> gói học phí <b>12 tháng</b>, không áp dụng chính sách ca 1 và ca 3 tại các Trung tâm.</li>
                                        <p className="rule-notice"> * Chi tiết vui lòng tham khảo email gửi mã voucher</p>
                                    </ul>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <div className="content-left">
                                <span className="content-title">
                                    THỜI HẠN ĐĂNG KÝ CÒN:
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="offset-md-1 col-md-10">
                            <div className="countdown-container">

                                <div className="countdown-item">
                                    <div className="countdown-title">
                                        NGÀY
                                    </div>
                                    <p className="countdown-number">
                                        {remainDay}
                                    </p>
                                </div>
                                <div className="countdown-item">
                                    <div className="countdown-title">
                                        GIỜ
                                    </div>
                                    <p className="countdown-number">
                                        {remainHour}
                                    </p>
                                </div>
                                <div className="countdown-item">
                                    <div className="countdown-title">
                                        PHÚT
                                    </div>
                                    <p className="countdown-number">
                                        {remainMinute}
                                    </p>
                                </div>
                                <div className="countdown-item">
                                    <div className="countdown-title">
                                        GIÂY
                                    </div>
                                    <p className="countdown-number" style={{ borderRight: 0 }}>
                                        {remaiSecond}
                                    </p>
                                </div>
                            </div>
                            <button id="reg" className={'register-btn'} onClick={() => setisOpenDialogReg(true)}> ĐĂNG KÝ
                            </button>
                            <button className={isFixedBtn ? 'register-btn register-btn-fixed' : 'd-none'} onClick={() => setisOpenDialogReg(true)}> ĐĂNG KÝ
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row footer">
                <div className="container-fluid custom-container" >
                    <div className="row mt-4 text-left">
                        <div className="col-md-6">
                            <p className="company-title">
                                CÔNG TY CỔ PHẦN ANH NGỮ APAX
                            </p>
                            <p className="company-location">
                                {`HỘI SỞ CHÍNH 
                                MIỀN BẮC - MIỀN TRUNG
                                Tầng 10, tòa nhà 14 Láng Hạ, Ba Đình, Hanoi
                                Hotline: 1900 633 979

                                VĂN PHÒNG - MIỀN NAM
                                Tầng 5 Tòa nhà Báo Lao động, 198 Nguyễn Thị Minh Khai, Phường 6, Quận 3, TP.HCM`}
                            </p>
                        </div>
                        <div className="col-md-6">
                            <div className="follow-container">

                                <div className="follow-title">
                                    THEO DÕI CHÚNG TÔI
                                </div>
                                <div >
                                    <div className="follow-button-container">
                                        <IconButton className="follow-icon-btn">
                                            <InstagramIcon />
                                        </IconButton>
                                        <IconButton className="follow-icon-btn">
                                            <YouTubeIcon />
                                        </IconButton>
                                        <IconButton className="follow-icon-btn">
                                            <a href="https://www.facebook.com/ApaxEnglish" target="_blank" style={{ color: 'white' }}>

                                                <FacebookIcon />
                                            </a>
                                        </IconButton>
                                        <IconButton className="follow-icon-btn">
                                            <GoogleIcon />
                                        </IconButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <FormReg isOpenDialogReg={isOpenDialogReg} handleCloseDialog={() => setisOpenDialogReg(false)} />
        </div>
    )
}
